export default "__VITE_ASSET__ca0a151f__"